"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("underscore");
const core_1 = require("@angular/core");
const reporting_service_1 = require("../reporting.service");
require("../Models");
const dnaR_dropdown_multiSelect_model_1 = require("../../common/components/dnaR-dropdown-multiSelect/dnaR-dropdown-multiSelect.model");
const common_1 = require("@angular/common");
const movement_enum_1 = require("./enums/movement.enum");
const care_type_enum_1 = require("./enums/care-type.enum");
const dnaRSnackBar_service_1 = require("../../common/dna-r/dnaRSnackBar.service");
require("../../common/components/dnaR-paginator/dnaR-paginator.component");
const uuid = require("uuid");
const devextreme_angular_1 = require("devextreme-angular");
const i0 = require("@angular/core");
const i1 = require("../reporting.service");
const i2 = require("../../common/dna-r/dnaRSnackBar.service");
const i3 = require("@angular/common");
const i4 = require("@angular/forms");
const i5 = require("../../common/components/dnaR-datePicker/dnaR-datePicker.component");
const i6 = require("../../common/components/dnaR-dropdown-multiSelect/dnaR-dropdown-multiSelect.component");
const i7 = require("devextreme-angular");
const i8 = require("devextreme-angular/ui/nested");
const i9 = require("../../common/components/dnaR-paginator/dnaR-paginator.component");
function MovementsReportComponent_div_49_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("\n                        ", ctx_r0.dateValidationError, "\n                    ");
} }
function MovementsReportComponent_label_61_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.selectedFacility.text);
} }
function MovementsReportComponent_dnaR_dropdown_multiSelect_63_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "dnaR-dropdown-multiSelect", 27);
    i0.ɵɵlistener("initialSelectedItemsChange", function MovementsReportComponent_dnaR_dropdown_multiSelect_63_Template_dnaR_dropdown_multiSelect_initialSelectedItemsChange_0_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.selectedFacilityIds = $event; })("initialSelectedItemsChange", function MovementsReportComponent_dnaR_dropdown_multiSelect_63_Template_dnaR_dropdown_multiSelect_initialSelectedItemsChange_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.loadMovementsReportData(); });
    i0.ɵɵtext(1, "\n                    ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("settings", ctx_r2.dropdownSettings)("data", ctx_r2.facilities)("initialSelectedItems", ctx_r2.selectedFacilityIds);
} }
function MovementsReportComponent_label_76_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.careTypes[0].name);
} }
function MovementsReportComponent_dnaR_dropdown_multiSelect_78_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "dnaR-dropdown-multiSelect", 28);
    i0.ɵɵlistener("initialSelectedItemsChange", function MovementsReportComponent_dnaR_dropdown_multiSelect_78_Template_dnaR_dropdown_multiSelect_initialSelectedItemsChange_0_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.selectedCareTypeIds = $event; })("initialSelectedItemsChange", function MovementsReportComponent_dnaR_dropdown_multiSelect_78_Template_dnaR_dropdown_multiSelect_initialSelectedItemsChange_0_listener() { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.loadMovementsReportData(); });
    i0.ɵɵtext(1, "\n                    ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("settings", ctx_r4.dropdownSettings)("data", ctx_r4.careTypes)("initialSelectedItems", ctx_r4.selectedCareTypeIds);
} }
function MovementsReportComponent_label_90_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r5.movements[0].name);
} }
function MovementsReportComponent_dnaR_dropdown_multiSelect_92_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "dnaR-dropdown-multiSelect", 29);
    i0.ɵɵlistener("initialSelectedItemsChange", function MovementsReportComponent_dnaR_dropdown_multiSelect_92_Template_dnaR_dropdown_multiSelect_initialSelectedItemsChange_0_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.selectedMovementIds = $event; })("initialSelectedItemsChange", function MovementsReportComponent_dnaR_dropdown_multiSelect_92_Template_dnaR_dropdown_multiSelect_initialSelectedItemsChange_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.loadMovementsReportData(); });
    i0.ɵɵtext(1, "\n                    ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("settings", ctx_r6.dropdownSettings)("data", ctx_r6.movements)("initialSelectedItems", ctx_r6.selectedMovementIds);
} }
const _c0 = function () { return ["facility", "lastName", "firstName", "careRecipientId", "careType", "movement", "startDate", "endDate", "expectedReturnDate", "daysForPeriod", "totalDays"]; };
function MovementsReportComponent_div_98_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtext(1, "\n        ");
    i0.ɵɵelementStart(2, "div", 31);
    i0.ɵɵtext(3, "Showing ");
    i0.ɵɵelementStart(4, "strong");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6, " from ");
    i0.ɵɵelementStart(7, "strong");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(10, " to\n            ");
    i0.ɵɵelementStart(11, "strong");
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(14, "\n        ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(15, "\n        ");
    i0.ɵɵelementStart(16, "dx-data-grid", 32, 33);
    i0.ɵɵtext(18, "\n            ");
    i0.ɵɵelement(19, "dxo-paging", 34);
    i0.ɵɵtext(20, "\n            ");
    i0.ɵɵelement(21, "dxo-load-panel", 34);
    i0.ɵɵtext(22, "\n            ");
    i0.ɵɵelementStart(23, "dxi-column", 35);
    i0.ɵɵtext(24, "\n            ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(25, "\n            ");
    i0.ɵɵelementStart(26, "dxi-column", 36);
    i0.ɵɵtext(27, "\n            ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(28, "\n            ");
    i0.ɵɵelementStart(29, "dxi-column", 37);
    i0.ɵɵtext(30, "\n            ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(31, "\n            ");
    i0.ɵɵelementStart(32, "dxi-column", 38);
    i0.ɵɵtext(33, "\n            ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(34, "\n            ");
    i0.ɵɵelementStart(35, "dxi-column", 39);
    i0.ɵɵtext(36, "\n            ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(37, "\n            ");
    i0.ɵɵelementStart(38, "dxi-column", 40);
    i0.ɵɵtext(39, "\n            ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(40, "\n            ");
    i0.ɵɵelementStart(41, "dxi-column", 41);
    i0.ɵɵtext(42, "\n            ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(43, "\n            ");
    i0.ɵɵelementStart(44, "dxi-column", 42);
    i0.ɵɵtext(45, "\n            ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(46, "\n            ");
    i0.ɵɵelementStart(47, "dxi-column", 43);
    i0.ɵɵtext(48, "\n            ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(49, "\n            ");
    i0.ɵɵelementStart(50, "dxi-column", 44);
    i0.ɵɵtext(51, "\n            ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(52, "\n            ");
    i0.ɵɵelementStart(53, "dxi-column", 45);
    i0.ɵɵtext(54, "\n            ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(55, "\n        ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(56, "\n        ");
    i0.ɵɵelementStart(57, "dnaR-paginator", 46);
    i0.ɵɵlistener("page", function MovementsReportComponent_div_98_Template_dnaR_paginator_page_57_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(); return ctx_r19.handlePageEvent($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(58, "\n    ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1("", ctx_r7.totalRecords, " movements");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(9, 35, ctx_r7.fromDateUtc, "dd-MMM-yyyy"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(13, 38, ctx_r7.toDateUtc, "dd-MMM-yyyy"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("dataSource", ctx_r7.movementsReportData)("columns", i0.ɵɵpureFunction0(41, _c0))("showBorders", false)("showColumnLines", false)("showRowLines", true)("cellHintEnabled", true)("allowColumnResizing", true)("columnAutoWidth", true);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("enabled", false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("enabled", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("allowSorting", false);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("allowSorting", false);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("allowSorting", false);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("width", 119)("allowSorting", false);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("allowSorting", false);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("allowSorting", false);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("width", 110)("allowSorting", false);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("width", 110)("allowSorting", false);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("width", 145)("allowSorting", false);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("width", 125)("allowSorting", false);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("width", 77)("allowSorting", false);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("length", ctx_r7.totalRecords)("pageSize", ctx_r7.pageSize)("pageSizeOptions", ctx_r7.pageSizeOptions)("pageIndex", ctx_r7.pageIndex)("itemsDisplayLabel", "Items");
} }
function MovementsReportComponent_div_100_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵtext(1, "    \n        ");
    i0.ɵɵelement(2, "div", 48);
    i0.ɵɵtext(3, "\n        ");
    i0.ɵɵelementStart(4, "div", 49);
    i0.ɵɵtext(5, "No results");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6, "\n        ");
    i0.ɵɵelementStart(7, "div", 50);
    i0.ɵɵtext(8, "\n            Try removing some filters.\n        ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(9, "\n    ");
    i0.ɵɵelementEnd();
} }
class MovementsReportComponent {
    constructor(reportingService, snackBarService, facilityService, downloadFileService, datePipe) {
        this.reportingService = reportingService;
        this.snackBarService = snackBarService;
        this.facilityService = facilityService;
        this.downloadFileService = downloadFileService;
        this.datePipe = datePipe;
        this.dropdownSettings = {
            singleSelection: true,
            idField: 'id',
            textField: 'name',
            itemsShowLimit: 1,
            maxHeight: 500,
            addAllOption: false,
            enableCheckAll: false,
            showClearSelectedItems: false
        };
        this.facilitiesList = [];
        // If Enum Key and Value are same - use Object.keys to get the index
        // If Enum key and Value are not same - use Object.values to get the index
        this.careTypes = [
            { name: care_type_enum_1.CareTypeEnum.All, id: Object.keys(care_type_enum_1.CareTypeEnum).indexOf(care_type_enum_1.CareTypeEnum.All) },
            { name: care_type_enum_1.CareTypeEnum.ConvertedToPermanent, id: Object.values(care_type_enum_1.CareTypeEnum).indexOf(care_type_enum_1.CareTypeEnum.ConvertedToPermanent) },
            { name: care_type_enum_1.CareTypeEnum.Deceased, id: Object.keys(care_type_enum_1.CareTypeEnum).indexOf(care_type_enum_1.CareTypeEnum.Deceased) },
            { name: care_type_enum_1.CareTypeEnum.Permanent, id: Object.keys(care_type_enum_1.CareTypeEnum).indexOf(care_type_enum_1.CareTypeEnum.Permanent) },
            { name: care_type_enum_1.CareTypeEnum.Respite, id: Object.keys(care_type_enum_1.CareTypeEnum).indexOf(care_type_enum_1.CareTypeEnum.Respite) },
        ];
        this.movements = [
            { name: movement_enum_1.MovementEnum.All, id: Object.keys(movement_enum_1.MovementEnum).indexOf(movement_enum_1.MovementEnum.All) },
            { name: movement_enum_1.MovementEnum.AdmissionOrDeparture, id: Object.values(movement_enum_1.MovementEnum).indexOf(movement_enum_1.MovementEnum.AdmissionOrDeparture) },
            { name: movement_enum_1.MovementEnum.EmergencyLeave, id: Object.values(movement_enum_1.MovementEnum).indexOf(movement_enum_1.MovementEnum.EmergencyLeave) },
            { name: movement_enum_1.MovementEnum.HospitalLeave, id: Object.values(movement_enum_1.MovementEnum).indexOf(movement_enum_1.MovementEnum.HospitalLeave) },
            { name: movement_enum_1.MovementEnum.SocialLeave, id: Object.values(movement_enum_1.MovementEnum).indexOf(movement_enum_1.MovementEnum.SocialLeave) },
            { name: movement_enum_1.MovementEnum.TransitionCareLeave, id: Object.values(movement_enum_1.MovementEnum).indexOf(movement_enum_1.MovementEnum.TransitionCareLeave) }
        ];
        this.movementsReportData = null;
        this.pageSize = 50;
        this.pageSizeOptions = [50, 100, 'All'];
        this.pageIndex = 0;
        this.hasData = true;
        this.initialiseFilters = () => {
            this.facilities = this.facilityService.activeUserFacilities.filter(x => x.facilityType == "AgeCare");
            if (this.facilities.length != 1) {
                this.facilities.unshift({ id: 0, name: "All", facilityType: "AgeCare", isBillingIntegratedFacility: false });
                this.facilities.forEach((facility) => {
                    this.facilitiesList.push(new dnaR_dropdown_multiSelect_model_1.ListItem({ id: facility.id, text: facility.name }));
                });
            }
            this.selectedFacility = { id: this.facilities[0].id.toString(), text: this.facilities[0].name, isHeader: false };
            this.selectedFacilityIds = [this.selectedFacility.id];
            this.selectedCareType = this.careTypes[0].id;
            this.selectedCareTypeIds = [this.careTypes[0].id.toString()];
            this.selectedMovement = this.movements[0].id;
            this.selectedMovementIds = [this.movements[0].id.toString()];
        };
        this.onSubmit = () => {
            this.getReportFilters();
            const runDateTime = this.datePipe.transform(new Date(), 'yyyy-MM-dd_HH.mm.ss');
            const fileName = `Movements Report - ${runDateTime}.xlsx`;
            this.reportingService.getMovementsReportExcelStream(this.reportFilters).then((response) => {
                this.downloadFile(response, fileName);
            }, () => {
                this.snackBarService.failure("Error occurred while exporting Movements report");
            });
        };
        this.downloadFile = (response, fileName) => {
            this.downloadFileService.downloadFile(response, fileName);
        };
        const date = new Date();
        this.fromDateUtc = new Date(date.getFullYear(), date.getMonth(), 1);
        this.toDateUtc = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.initialiseFilters();
    }
    ngOnInit() {
        this.loadMovementsReportData();
    }
    ngAfterViewInit() {
        if (this.movementsReportData === null) {
            this.beginCustomLoading();
        }
    }
    // makes mocking simpler
    beginCustomLoading() {
        var _a, _b;
        (_b = (_a = this.dataGrid) === null || _a === void 0 ? void 0 : _a.instance) === null || _b === void 0 ? void 0 : _b.beginCustomLoading("");
    }
    // makes mocking simpler
    endCustomLoading() {
        var _a, _b;
        (_b = (_a = this.dataGrid) === null || _a === void 0 ? void 0 : _a.instance) === null || _b === void 0 ? void 0 : _b.endCustomLoading();
    }
    dateValidation() {
        this.dateValidationError = null;
        let itemStartDate = new Date(this.fromDateUtc);
        let itemEndDate = new Date(this.toDateUtc);
        // If we have start and end, validate the end date is after start date
        if (this.fromDateUtc && this.toDateUtc) {
            if (itemStartDate > itemEndDate) {
                this.dateValidationError = "End date must be after start date";
            }
            else {
                this.loadMovementsReportData();
            }
        }
    }
    ;
    convertDateToUtcMidNight(date) {
        if (date) {
            return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0));
        }
    }
    loadMovementsReportData() {
        let skip = null;
        let take = null;
        // Calculate pagination values only if isn't a number (ie 'All')
        if (!isNaN(this.pageSize)) {
            skip = this.pageSize * this.pageIndex;
            take = Number(this.pageSize);
        }
        this.requestId = uuid.v4();
        this.getReportFilters();
        this.beginCustomLoading();
        this.reportingService.getMovementsReportData(this.requestId, skip, take, this.reportFilters).then((response) => {
            if (this.requestId == response.requestId) {
                this.movementsReportData = response.result;
                this.totalRecords = response.totalCount;
                this.hasData = response.result.length > 0;
                this.endCustomLoading();
            }
        }, () => {
            this.endCustomLoading();
            this.hasData = false;
            this.snackBarService.failure("Error occurred while loading Movements report");
        });
    }
    getReportFilters() {
        var _a, _b, _c;
        this.reportFilters = {
            fromDate: this.convertDateToUtcMidNight(this.fromDateUtc),
            toDate: this.convertDateToUtcMidNight(this.toDateUtc),
            facility: this.selectedFacilityIds && this.selectedFacilityIds.length > 0 ? (_a = this.facilities.find(x => x.id.toString() == this.selectedFacilityIds[0])) === null || _a === void 0 ? void 0 : _a.name : 'All',
            careType: this.selectedCareTypeIds && this.selectedCareTypeIds.length > 0 ? (_b = this.careTypes.find(x => x.id.toString() == this.selectedCareTypeIds[0])) === null || _b === void 0 ? void 0 : _b.name : 'All',
            movement: this.selectedMovementIds && this.selectedMovementIds.length > 0 ? (_c = this.movements.find(x => x.id.toString() == this.selectedMovementIds[0])) === null || _c === void 0 ? void 0 : _c.name : 'All'
        };
    }
    handlePageEvent(e) {
        this.totalRecords = e.length;
        this.pageSize = e.pageSize;
        this.pageIndex = e.pageIndex;
        this.loadMovementsReportData();
    }
}
exports.MovementsReportComponent = MovementsReportComponent;
MovementsReportComponent.ɵfac = function MovementsReportComponent_Factory(t) { return new (t || MovementsReportComponent)(i0.ɵɵdirectiveInject(i1.ReportingService), i0.ɵɵdirectiveInject(i2.DnaRSnackBarService), i0.ɵɵdirectiveInject('facility.service'), i0.ɵɵdirectiveInject('downloadFile.service'), i0.ɵɵdirectiveInject(i3.DatePipe)); };
MovementsReportComponent.ɵcmp = i0.ɵɵdefineComponent({ type: MovementsReportComponent, selectors: [["movements-report"]], viewQuery: function MovementsReportComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(devextreme_angular_1.DxDataGridComponent, true);
    } if (rf & 2) {
        var _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dataGrid = _t.first);
    } }, decls: 102, vars: 12, consts: [["nav-publisher", "reporting", 1, "movements-report"], ["novalidate", "", 1, "report-filters", 3, "ngSubmit"], [1, "row"], [1, "col-xs-6", "header"], [1, "page-header"], [1, "col-xs-6", "export-button"], ["type", "submit", 1, "btn", "btn-secondary", "btn-lg", 3, "disabled"], [1, "row", "movements-report-row"], [1, "col-xs-2", "movements-report-field-width"], [1, "movements-report-label"], ["for", "fromDate", 1, "control-label", "v-align-middle"], [1, "movements-report-field"], ["name", "startDate", "ngDefaultControl", "", "required", "true", "requiredError", "Start date required", 3, "ngModel", "ngModelChange", "onComponentChange"], ["for", "toDate", 1, "control-label", "v-align-middle"], ["name", "endDate", "ngDefaultControl", "", "required", "false", 3, "ngModel", "ngModelChange", "onComponentChange"], ["class", "text-danger", 4, "ngIf"], ["for", "facility", 1, "control-label", "label-facility"], ["class", "control-label no-margin v-align-middle", 4, "ngIf"], ["name", "facility", "data-automation", "facilities", 3, "settings", "data", "initialSelectedItems", "initialSelectedItemsChange", 4, "ngIf"], ["for", "type", 1, "control-label", "label-type"], ["name", "careType", "data-automation", "careTypes", 3, "settings", "data", "initialSelectedItems", "initialSelectedItemsChange", 4, "ngIf"], ["for", "movement", 1, "control-label", "label-movement"], ["name", "movement", "data-automation", "movements", 3, "settings", "data", "initialSelectedItems", "initialSelectedItemsChange", 4, "ngIf"], ["class", "row report-table", 4, "ngIf"], ["class", "row no-movements", 4, "ngIf"], [1, "text-danger"], [1, "control-label", "no-margin", "v-align-middle"], ["name", "facility", "data-automation", "facilities", 3, "settings", "data", "initialSelectedItems", "initialSelectedItemsChange"], ["name", "careType", "data-automation", "careTypes", 3, "settings", "data", "initialSelectedItems", "initialSelectedItemsChange"], ["name", "movement", "data-automation", "movements", 3, "settings", "data", "initialSelectedItems", "initialSelectedItemsChange"], [1, "row", "report-table"], [1, "records-count"], ["id", "dataGrid", "noDataText", "", 3, "dataSource", "columns", "showBorders", "showColumnLines", "showRowLines", "cellHintEnabled", "allowColumnResizing", "columnAutoWidth"], ["dataGrid", ""], [3, "enabled"], ["cssClass", "text-wrap", "dataField", "facility", "alignment", "left", "dataType", "string", "caption", "Facility", 3, "allowSorting"], ["cssClass", "text-wrap", "dataField", "lastName", "alignment", "left", "dataType", "string", "caption", "Last name", 3, "allowSorting"], ["cssClass", "text-wrap", "dataField", "firstName", "alignment", "left", "dataType", "string", "caption", "First name", 3, "allowSorting"], ["cssClass", "text-wrap", "dataField", "careRecipientId", "alignment", "left", "dataType", "string", "caption", "Care recipient ID", 3, "width", "allowSorting"], ["cssClass", "text-wrap", "dataField", "careType", "alignment", "left", "dataType", "string", "caption", "Care type", 3, "allowSorting"], ["cssClass", "text-wrap", "dataField", "movement", "alignment", "left", "dataType", "string", "caption", "Movement", 3, "allowSorting"], ["cssClass", "text-wrap", "dataField", "startDate", "alignment", "left", "format", "dd-MMM-yyyy", "dataType", "date", "caption", "Start date", 3, "width", "allowSorting"], ["cssClass", "text-wrap", "dataField", "endDate", "alignment", "left", "format", "dd-MMM-yyyy", "dataType", "date", "caption", "End date", 3, "width", "allowSorting"], ["cssClass", "text-wrap", "dataField", "expectedReturnDate", "alignment", "left", "format", "dd-MMM-yyyy", "dataType", "date", "caption", "Expected return date", 3, "width", "allowSorting"], ["cssClass", "text-wrap", "dataField", "daysForPeriod", "alignment", "left", "dataType", "number", "caption", "Days (this period)", 3, "width", "allowSorting"], ["cssClass", "text-wrap", "dataField", "totalDays", "alignment", "left", "dataType", "number", "caption", "Total days", 3, "width", "allowSorting"], [3, "length", "pageSize", "pageSizeOptions", "pageIndex", "itemsDisplayLabel", "page"], [1, "row", "no-movements"], [1, "empty-icon"], [1, "no-movements-text"], [1, "movements-help-text"]], template: function MovementsReportComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtext(1, "\n    ");
        i0.ɵɵelementStart(2, "form", 1);
        i0.ɵɵlistener("ngSubmit", function MovementsReportComponent_Template_form_ngSubmit_2_listener() { return ctx.onSubmit(); });
        i0.ɵɵtext(3, "\n        ");
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵtext(5, "\n            ");
        i0.ɵɵelementStart(6, "div", 3);
        i0.ɵɵtext(7, "\n                ");
        i0.ɵɵelementStart(8, "h1", 4);
        i0.ɵɵtext(9, "Movements");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(10, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(11, "\n            ");
        i0.ɵɵelementStart(12, "div", 5);
        i0.ɵɵtext(13, "\n                ");
        i0.ɵɵelementStart(14, "button", 6);
        i0.ɵɵtext(15, "Export");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(16, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(17, "\n        ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(18, "\n        ");
        i0.ɵɵelementStart(19, "div", 7);
        i0.ɵɵtext(20, "\n            ");
        i0.ɵɵelementStart(21, "div", 8);
        i0.ɵɵtext(22, "\n                ");
        i0.ɵɵelementStart(23, "div", 9);
        i0.ɵɵtext(24, "\n                    ");
        i0.ɵɵelementStart(25, "label", 10);
        i0.ɵɵtext(26, "From");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(27, "\n                ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(28, "\n                ");
        i0.ɵɵelementStart(29, "div", 11);
        i0.ɵɵtext(30, "\n                    ");
        i0.ɵɵelementStart(31, "dnaR-date-picker", 12);
        i0.ɵɵlistener("ngModelChange", function MovementsReportComponent_Template_dnaR_date_picker_ngModelChange_31_listener($event) { return ctx.fromDateUtc = $event; })("onComponentChange", function MovementsReportComponent_Template_dnaR_date_picker_onComponentChange_31_listener() { return ctx.dateValidation(); });
        i0.ɵɵtext(32, "\n                    ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(33, "\n                ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(34, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(35, "\n            ");
        i0.ɵɵelementStart(36, "div", 8);
        i0.ɵɵtext(37, "\n                ");
        i0.ɵɵelementStart(38, "div", 9);
        i0.ɵɵtext(39, "\n                    ");
        i0.ɵɵelementStart(40, "label", 13);
        i0.ɵɵtext(41, "To");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(42, "\n                ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(43, "\n                ");
        i0.ɵɵelementStart(44, "div", 11);
        i0.ɵɵtext(45, "\n                    ");
        i0.ɵɵelementStart(46, "dnaR-date-picker", 14);
        i0.ɵɵlistener("ngModelChange", function MovementsReportComponent_Template_dnaR_date_picker_ngModelChange_46_listener($event) { return ctx.toDateUtc = $event; })("onComponentChange", function MovementsReportComponent_Template_dnaR_date_picker_onComponentChange_46_listener() { return ctx.dateValidation(); });
        i0.ɵɵtext(47, "\n                    ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(48, "\n                    ");
        i0.ɵɵtemplate(49, MovementsReportComponent_div_49_Template, 2, 1, "div", 15);
        i0.ɵɵtext(50, "\n                ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(51, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(52, "\n            ");
        i0.ɵɵelementStart(53, "div", 8);
        i0.ɵɵtext(54, "\n                ");
        i0.ɵɵelementStart(55, "div", 9);
        i0.ɵɵelementStart(56, "label", 16);
        i0.ɵɵtext(57, "Facility");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtext(58, "\n                ");
        i0.ɵɵelementStart(59, "div", 11);
        i0.ɵɵtext(60, "\n                    ");
        i0.ɵɵtemplate(61, MovementsReportComponent_label_61_Template, 2, 1, "label", 17);
        i0.ɵɵtext(62, "\n                    ");
        i0.ɵɵtemplate(63, MovementsReportComponent_dnaR_dropdown_multiSelect_63_Template, 2, 3, "dnaR-dropdown-multiSelect", 18);
        i0.ɵɵtext(64, "\n                ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(65, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(66, "\n            ");
        i0.ɵɵelementStart(67, "div", 8);
        i0.ɵɵtext(68, "\n                ");
        i0.ɵɵelementStart(69, "div", 9);
        i0.ɵɵelementStart(70, "label", 19);
        i0.ɵɵtext(71, "Type");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(72, "\n                ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(73, "\n                ");
        i0.ɵɵelementStart(74, "div", 11);
        i0.ɵɵtext(75, "\n                    ");
        i0.ɵɵtemplate(76, MovementsReportComponent_label_76_Template, 2, 1, "label", 17);
        i0.ɵɵtext(77, "\n                    ");
        i0.ɵɵtemplate(78, MovementsReportComponent_dnaR_dropdown_multiSelect_78_Template, 2, 3, "dnaR-dropdown-multiSelect", 20);
        i0.ɵɵtext(79, "\n                ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(80, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(81, "\n            ");
        i0.ɵɵelementStart(82, "div", 8);
        i0.ɵɵtext(83, "\n                ");
        i0.ɵɵelementStart(84, "div", 9);
        i0.ɵɵelementStart(85, "label", 21);
        i0.ɵɵtext(86, "Movement");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtext(87, "\n                ");
        i0.ɵɵelementStart(88, "div", 11);
        i0.ɵɵtext(89, "\n                    ");
        i0.ɵɵtemplate(90, MovementsReportComponent_label_90_Template, 2, 1, "label", 17);
        i0.ɵɵtext(91, "\n                    ");
        i0.ɵɵtemplate(92, MovementsReportComponent_dnaR_dropdown_multiSelect_92_Template, 2, 3, "dnaR-dropdown-multiSelect", 22);
        i0.ɵɵtext(93, "\n                ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(94, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(95, "\n        ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(96, "\n\n    ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(97, "\n\n    ");
        i0.ɵɵtemplate(98, MovementsReportComponent_div_98_Template, 59, 42, "div", 23);
        i0.ɵɵtext(99, "\n    ");
        i0.ɵɵtemplate(100, MovementsReportComponent_div_100_Template, 10, 0, "div", 24);
        i0.ɵɵtext(101, "\n");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(14);
        i0.ɵɵproperty("disabled", !ctx.fromDateUtc || !ctx.toDateUtc || ctx.toDateUtc < ctx.fromDateUtc);
        i0.ɵɵadvance(17);
        i0.ɵɵproperty("ngModel", ctx.fromDateUtc);
        i0.ɵɵadvance(15);
        i0.ɵɵproperty("ngModel", ctx.toDateUtc);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.dateValidationError);
        i0.ɵɵadvance(12);
        i0.ɵɵproperty("ngIf", ctx.facilities.length == 1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.facilities.length > 1);
        i0.ɵɵadvance(13);
        i0.ɵɵproperty("ngIf", ctx.careTypes.length == 1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.careTypes.length > 1);
        i0.ɵɵadvance(12);
        i0.ɵɵproperty("ngIf", ctx.movements.length == 1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.movements.length > 1);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.hasData);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.hasData);
    } }, directives: [i4.ɵangular_packages_forms_forms_y, i4.NgControlStatusGroup, i4.NgForm, i5.DnaRDatePicker, i4.DefaultValueAccessor, i4.RequiredValidator, i4.NgControlStatus, i4.NgModel, i3.NgIf, i6.DnaRDropdownMultiSelect, i7.DxDataGridComponent, i8.DxoPagingComponent, i8.DxoLoadPanelComponent, i8.DxiColumnComponent, i9.DnaRPaginator], pipes: [i3.DatePipe], styles: [".report-filters[_ngcontent-%COMP%] {\n  padding-left: 16px;\n  padding-right: 16px;\n}\n.movements-report-row[_ngcontent-%COMP%] {\n  height: auto;\n  padding-bottom: 20px;\n}\n.movements-report-field[_ngcontent-%COMP%] {\n  padding-right: 15px;\n  color: #414141;\n  margin-left: -15px;\n  margin-right: -15px;\n}\n.movements-report-label[_ngcontent-%COMP%] {\n  padding-top: 5px;\n  color: #414141;\n  text-align: left;\n  margin-left: -15px;\n  margin-right: -15px;\n}\n.no-margin[_ngcontent-%COMP%] {\n  margin: 0px;\n}\n.export-button[_ngcontent-%COMP%] {\n  text-align: right;\n  margin: 40px 0 20px;\n  padding-right: 0px;\n}\n.header[_ngcontent-%COMP%] {\n  padding-left: 0px;\n}\n  .movements-report .report-table .dx-widget {\n  font-family: 'Source Sans Pro' !important;\n}\n  .movements-report .report-table .dx-datagrid-headers {\n  font-weight: 600;\n  color: #595959;\n}\n  .movements-report .report-table .dx-datagrid .dx-row-lines > td {\n  font-size: 16px;\n  color: #595959;\n}\n  .movements-report .report-table .text-wrap {\n  word-wrap: break-word;\n  white-space: pre-wrap;\n}\n  .movements-report .report-table .dx-datagrid-headers .dx-datagrid-table .dx-row {\n  border-top: 2px solid #D2D2D2 !important;\n}\n  .movements-report .report-table .dx-datagrid-headers .dx-datagrid-table .dx-row > td {\n  padding-top: 18px;\n  padding-bottom: 18px;\n}\n  .movements-report .dna-r-paginator {\n  border-top: 1px solid #D2D2D2;\n}\n.no-movements[_ngcontent-%COMP%] {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 45px;\n}\n.no-movements[_ngcontent-%COMP%]   .empty-icon[_ngcontent-%COMP%] {\n  width: 242px;\n  height: 227.47px;\n  flex-shrink: 0;\n  background-color: none;\n  background-image: url('images/emptyIllustration.svg');\n  background-repeat: no-repeat;\n}\n.no-movements[_ngcontent-%COMP%]   .no-movements-text[_ngcontent-%COMP%] {\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 28px;\n  \n  letter-spacing: -0.2px;\n  margin-top: 25px;\n}\n.no-movements[_ngcontent-%COMP%]   .movements-help-text[_ngcontent-%COMP%] {\n  color: #595959;\n}\n.records-count[_ngcontent-%COMP%] {\n  padding-bottom: 12px;\n  padding-left: 16px;\n}\n.movements-report-field-width[_ngcontent-%COMP%] {\n  width: 235px;\n}\n   .container.main-container:has(.movements-report) {\n  width: 100%;\n}"] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(MovementsReportComponent, [{
        type: core_1.Component,
        args: [{
                selector: 'movements-report',
                templateUrl: './movements-report.component.html',
                styleUrls: ['./movements-report.component.less'],
                preserveWhitespaces: true
            }]
    }], function () { return [{ type: i1.ReportingService }, { type: i2.DnaRSnackBarService }, { type: undefined, decorators: [{
                type: core_1.Inject,
                args: ['facility.service']
            }] }, { type: undefined, decorators: [{
                type: core_1.Inject,
                args: ['downloadFile.service']
            }] }, { type: i3.DatePipe }]; }, { dataGrid: [{
            type: core_1.ViewChild,
            args: [devextreme_angular_1.DxDataGridComponent]
        }] }); })();
